import pack1Front from '~/features/packs/assets/pack1-front.webp'
import pack2Front from '~/features/packs/assets/pack2-front.webp'
import pack3Front from '~/features/packs/assets/pack3-front.webp'
import vintageFront from '~/features/packs/assets/pack-vintage-front.webp'
import pack1Back from '~/features/packs/assets/pack1-back.webp'
import pack2Back from '~/features/packs/assets/pack2-back.webp'
import pack3Back from '~/features/packs/assets/pack3-back.webp'
import vintageBack from '~/features/packs/assets/pack-vintage-back.webp'

/** The cover artworks a pack can wear.
 *
 *  The database stores the KEY; the files live here. A pack is a 3D model whose
 *  front and back are textures, so what the server needs to know is which pair
 *  to use -- not a URL the model cannot texture from without another round
 *  trip. Keys mirror `Pack.Art` in `packs/models/pack.py`; adding a fourth is
 *  two files and one line in each.
 */
export type PackArtKey = 'pack1' | 'pack2' | 'pack3' | 'vintage'

export const PACK_ART: Record<PackArtKey, { label: string; front: string; back: string }> = {
    pack1: { label: 'Pack 1', front: pack1Front, back: pack1Back },
    pack2: { label: 'Pack 2', front: pack2Front, back: pack2Back },
    pack3: { label: 'Pack 3', front: pack3Front, back: pack3Back },
    vintage: { label: 'Vintage', front: vintageFront, back: vintageBack },
}

/** The art for a pack, falling back rather than rendering an empty stage: a
 *  pack written before this field existed, or carrying a key this build does
 *  not know, still has to show something. */
export const artFor = (key?: string | null) =>
    PACK_ART[(key as PackArtKey) ?? 'pack1'] ?? PACK_ART.pack1
